// src/utils/apiUtils.js
export const getApiUrl = (endpoint) => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiVersion = process.env.REACT_APP_DEFAULT_API_VERSION;

    return `${baseUrl}/${apiUrl}/${apiVersion}/${endpoint}`;
};
